import styled from "styled-components";
import { colors } from "../../utils";

export const AuthorIcon = styled.div`
  width: 55px;
  height: 55px;
  background-color: ${colors.lightBlue};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;

  &:hover {
    cursor: pointer;
  }
`;

export const AuthorInfo = styled.div`
  background-color: ${colors.background};
  width: 19vw;
  border-radius: 10px;
  padding: 10px;
`;

export const AuthorHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;
export const LeftView = styled.div`
  display: flex;
  align-items: center;
`;

export const ImageView = styled.div`
  width: 25px;
  height: 25px;
  display: flex;
  background-color: ${colors.lightBlue};
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  margin-right: 10px;
`;

export const AuthorView = styled.div`
  display: flex;
  background-color: ${colors.background};
  align-items: center;
  padding: 10px;
  border-radius: 5px;
`;

export const OtherAuthors = styled.div`
  background: linear-gradient(
      90deg,
      #f7fed5 0.51%,
      #ccfeff 35.32%,
      #fdcffe 60.23%,
      #f5eede 96.53%
    ),
    linear-gradient(0deg, rgba(255, 255, 255, 0.65), rgba(255, 255, 255, 0.65));
  margin-top: 10px;
  border-radius: 5px;
  padding: 5px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px;
`;

export const OtherAuthorView = styled.div`
  background-color: ${colors.white};
  border-radius: 5px;
  max-height: 160px;
  overflow-y: scroll;
`;

export const OtherAuthorItem = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
`;

export const Separator = styled.div`
  width: 90%;
  height: 1px;
  background-color: ${colors.lightBorder};
  margin: auto;
`;

export const ClonedFrom = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px;
`;

export const Loader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: "100%";
`;
